import store from '@/store';
import { Menu } from '@/types';

export function filterMenus(menus: Menu[]): Menu[] {
  const userlevel = store.state.client?.user?.user_level;
  return menus.filter((menu) => {
    if (!(userlevel && menu.disallowed)) {
      return true;
    }

    return !menu.disallowed.includes(userlevel);
  });
}

/** Disable menu and all sub menus.
 *
 * This is done iteratively rather than recursively.
*/
export function disableMenuIter(menu: Menu, disabled: boolean) {
  const stack = [menu];
  while (stack.length > 0) {
    const m = stack.pop();
    if (m === undefined) {
      // eslint-disable-next-line no-continue
      continue;
    }

    // Disable if necessary
    if (!(m.disabled === undefined || m.unimplemented)) {
      m.disabled = disabled;
    }

    // Add sub menus
    if (m.menu !== undefined) {
      stack.push(...m.menu);
    }
  }
}

/** Recursively disable menu and all sub menus. */
export function disableMenu(menu: Menu | undefined, disabled: boolean) {
  if (menu === undefined) {
    return;
  }

  // Disable if necessary
  if (!(menu.disabled === undefined || menu.unimplemented)) {
    // eslint-disable-next-line no-param-reassign
    menu.disabled = disabled;
  }

  // Add sub menus
  if (menu.menu !== undefined) {
    menu.menu.forEach((submenu) => {
      disableMenu(submenu, disabled);
    });
  }
}
